export default () => ({
  init() {
    this.addToRecentlyViewed();
  },

  addToRecentlyViewed() {
    const productJson = this.$refs.productJson;
    if (!productJson) return;

    try {
      const product = JSON.parse(productJson.textContent);
      this.$store.recentlyViewed.addProduct(product);
    } catch (error) {
      console.error('Error adding product to recently viewed', error);
    }
  }
})